import { Box, Typography } from "@mui/material";
import LinkRouter from "components/navigation/LinkRouter";
import { Check, X, Minus, LucideProps } from "lucide-react";

interface MilestoneProps {
  label: string;
  url?: string;
}

const Badge = ({
  label,
  url,
  color,
  backgroundColor,
  borderColor,
  textColor,
  Icon,
}: {
  label: string;
  url?: string;
  color: string;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  Icon: React.ComponentType<LucideProps>;
}) => (
  <LinkRouter to={url} disabled={!url}>
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 1,
        py: 0.5,
        borderRadius: "9999px",
        backgroundColor,
        border: `1px solid ${borderColor}`,
        cursor: "pointer",
      }}
    >
      <Icon
        size={10}
        color={color}
        strokeWidth={2.5}
        style={{ marginRight: "4px" }}
      />
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: textColor,
        }}
      >
        {label}
      </Typography>
    </Box>
  </LinkRouter>
);

const SuccessBadge = (props: MilestoneProps) => (
  <Badge
    label={props.label}
    color="#10b981"
    backgroundColor="#d1fae5"
    borderColor="#a7f3d0"
    textColor="#059669"
    Icon={Check}
    url={props.url}
  />
);

const ErrorBadge = (props: MilestoneProps) => (
  <Badge
    label={props.label}
    color="#ef4444"
    backgroundColor="#fee2e2"
    borderColor="#fecaca"
    textColor="#dc2626"
    Icon={X}
    url={props.url}
  />
);

const PrimaryBadge = (props: MilestoneProps) => (
  <Badge
    label={props.label}
    color="#6b7280"
    backgroundColor="#f3f4f6"
    borderColor="#e5e7eb"
    textColor="#6b7280"
    Icon={Minus}
    url={props.url}
  />
);

type DynamicBadgeProps = {
  state?: "success" | "error" | "primary";
};
const DynamicBadge = ({
  state,
  ...props
}: DynamicBadgeProps & MilestoneProps) => {
  switch (state) {
    case "success":
      return <SuccessBadge {...props} />;
    case "error":
      return <ErrorBadge {...props} />;
    case "primary":
    default:
      return <PrimaryBadge {...props} />;
  }
};
export { DynamicBadge };
